import { render, staticRenderFns } from "./AssignmentsTable.vue?vue&type=template&id=64b5f94c&scoped=true"
import script from "./AssignmentsTable.vue?vue&type=script&lang=js"
export * from "./AssignmentsTable.vue?vue&type=script&lang=js"
import style0 from "./AssignmentsTable.vue?vue&type=style&index=0&id=64b5f94c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5f94c",
  null
  
)

export default component.exports